import { FormLabel, FormLabelProps } from '@chakra-ui/react';

export function TexasFormLabel(props: FormLabelProps) {
  return (
    <FormLabel {...props} mb={0}>
      {props.children}
    </FormLabel>
  );
}
